module.exports = __webpack_public_path__ + "img/showmorebgnews.c374ed37.jpg";